import React from 'react';
import { ExpandComponent } from '../expand-component/expand-component';
import "./styles.css";
import {experiences} from "./experiences"

export const ExperienceComponentV2 = () => (
	<React.Fragment>
        <div class="Experienceouter">
            <div class="title">
                <div class="focusSubTitle">
                    Work Experiences
                </div>
                <div class="focusingSubContent">
                    I like to broaden my views and understand current industry problems as well as expanding my networks.
                </div>
            </div>
            <div class="ExperienceMain">
                {
                    experiences.map((exp)=>{
                        return(
                            <ExpandComponent work={exp.place} title={exp.title} detail={exp.detail} url={exp.url} date={exp.date}/>
                        )
                    })
                }
                
            </div>
        </div>
	</React.Fragment>
);